import NewLogin from './container'

export default NewLogin
